import React from 'react'
import { Link } from 'react-router-dom'

import './UserPhoneVerification.css'
function IndexPage() {

    return (
        <>   
        {/* <!-- Card Body --> */}
        <section className="main-login">
          <div className='container-fluid'>
            <div className='row'>
                <div className='col-lg-4 col_center'>
                    <div className='login'>
                      <a className="sidebar-brand d-flex align-items-center justify-content-center" href="/LoginPage">
                          <div className="sidebar-brand-icon rotate-n-15">
                              <i className="fas fa-laugh-wink"></i>
                          </div>
                          <div className="sidebar-brand-text mx-3">Say Eagle</div>
                      </a>
                      <form>
                        <h1> We don't recognize the device you are logging in from.</h1>
                        <p>The device you are logging in from is not recognized. To log in, please choose how you would like to receive a verification code.</p>
                        
                        <div className="form-group form-check">
                          <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                          <label className="form-check-label" htmlFor="exampleCheck1">Receive code via SMS</label>
                        </div>
                        <div className="form-group form-check">
                          <input type="checkbox" className="form-check-input" id="exampleCheck1" />
                          <label className="form-check-label" htmlFor="exampleCheck1">Receive code via phone call</label>
                        </div>
                        <Link to='/SendOtpCode' className="btn btn-primary submit">Send Verification Code</Link> 
                      </form>
                    </div>
                    
                </div>
            </div>
          </div>
        </section>
        </>

    )
}

export default IndexPage
